import {Dispatch, FormEvent, SetStateAction} from 'react'
import {BASE_URL} from '../../config'

export const GET_RECHARGE_FROM_URL = `${BASE_URL}/api/protect/rechargeFrom`

export interface IRechargeData {
  id: number
  userId?: number | undefined
  name: string | undefined
  actionuser?: number
  rechargedate: string
  balance: number
  note: string
  rechargeby?: number
  paymentmethod: string
  type: string
  username: string
}

export interface IRechargeDataArray extends Array<IRechargeData> {}

export interface RechargeProps {
  apiUrl: string
  title: string
}

export interface SearchFormFIlterProps {
  startTime: string
  endTime: string
  itemsPerPage: number
  setStartTime: Dispatch<SetStateAction<string>>
  setEndTime: Dispatch<SetStateAction<string>>
  handleSearchSubmit: (event: FormEvent) => void
  setCurrentPage: Dispatch<SetStateAction<number>>
  setItemsPerPage: Dispatch<SetStateAction<number>>
  handleDownload?: (type: 'csv' | 'pdf' | 'excel') => void
}

export const GET_INVOICE_LIST_URL = `${BASE_URL}/api/protect/invoice/invoiceList`

export interface IInvoiceList {
  id: 148
  user_id: 1
  invoice_no: string
  invoice_date: string
  start_date: string
  end_date: string
  type: string
  sms_count: number
  sms_hit: number
  user_cost: number
  vat: number
  service_charge: number
  total_cost: number
  user_balance: number
  user_full_name: string
  user_mobile: string
  user_email: string
  create_date: string
}

export interface IInvoiceListArray extends Array<IInvoiceList> {}

export interface IBillOption {
  id: number
  optionsName: string
  optionsValue?: string
}

export interface IToBillDetails {
  user_full_name: string
  user_mobile: string
  user_email: string
  create_date: string
}

export interface InvoiceResponse {
  invoiceInfo: IInvoiceList
  fromBillDetails: IBillOption[]
  toBillDetails: IToBillDetails
}

export interface IinvoiceCreateForm {
  username: string
  userId: number | null
  startTime: string
  endTime: string
}

export interface IFilterInvoiceForm {
  username: string
  userId: number | null
  sdate: string
  edate: string
}

export const initInvoiceCreateFormValues: IinvoiceCreateForm = {
  username: '',
  userId: null,
  startTime: '',
  endTime: '',
}

export const initFilterInvoiceForm: IFilterInvoiceForm = {
  username: '',
  userId: null,
  sdate: '',
  edate: '',
}

export interface InvoiceItem {
  sl: number
  description: string
  quantity: number
  unitPrice: number
}

export interface IContact {
  deparment: string
  name: string
  phone: string
}

export interface InvoiceData {
  customerName: string
  customerBIN: string
  address: string
  attention: string
  customerNo: string

  providerName: string
  providerBIN: string
  providerAddress: string

  invoiceNo: string
  mushokNo: string
  issueDate: string
  lastPaymentDate: string
  billingPeriod: string

  items: InvoiceItem[]
  vatRate: number

  authorizedPerson: string
  designation: string

  contact: IContact[]
}

export const invoiceData: InvoiceData = {
  customerName: 'ABC Telecom',
  customerBIN: '123456',
  address: 'Dhaka',
  attention: 'Accounts Dept',
  customerNo: 'C-101',

  providerName: 'Red Data (Pvt.) Ltd.',
  providerBIN: '006342088-0505',
  providerAddress: 'Gulshan Ave, Dhaka',

  invoiceNo: 'RDPL-00001',
  mushokNo: 'M-0001',
  issueDate: '12-08-2025',
  lastPaymentDate: '20-08-2025',
  billingPeriod: 'August 2025',

  vatRate: 5,

  items: [
    {
      sl: 1,
      description: 'SMS (Non-Masking)',
      quantity: 10000,
      unitPrice: 0.14,
    },
  ],

  authorizedPerson: 'Mohaminur Rahman',
  designation: 'Executive',

  contact: [
    {
      deparment: 'Billing & Credit Control',
      name: 'Mohaimin Ur Rahman',
      phone: '01322937843',
    },
    {
      deparment: 'Billing & Credit Control',
      name: 'Famia Khan',
      phone: '01975662116',
    },
  ],
}
